import Rover from '@rover/globals/Rover';
import inject from '@rover/utilities/injector';
import { setupI18n } from '@lingui/core';
import reportError from '@rover/utilities/reportError';

const language = inject('Rover.context.language', 'en-us');
let catalogs = { [language]: {} };
try {
  catalogs = Rover.context.frontendTranslationEnabled
    ? // TODO: load all message catalogs (e.g. react-lib, react-app, etc)
      { [language]: require(`../app/locale/${language}/messages`) } // eslint-disable-line import/no-dynamic-require
    : catalogs;
} catch (err) {
  reportError(err);
}

const i18nConfig = {
  language,
  catalogs,
};

const i18n = setupI18n(i18nConfig);

export { i18n as default, i18nConfig };



// WEBPACK FOOTER //
// ../utilities/translation.js